import { isNil } from 'lodash-es';
import { LogOptionsHelper } from './log-options-helper';
import { LogAction, LogLevel, } from './type';
function unwrapOptions(payload) {
    if (typeof payload === 'string') {
        return {
            message: payload,
        };
    }
    return payload;
}
const defaultLogOptions = {
    level: LogLevel.INFO,
    action: [LogAction.CONSOLE],
};
export class BaseLogger {
    constructor({ ctx = {}, clients = [], beforeSend = [], disableConsole, }) {
        this.logOptionsResolvers = [];
        this.ctx = new LogOptionsHelper(ctx);
        this.clients = clients;
        this.logOptionsResolvers = beforeSend;
        this.disableConsole = disableConsole || false;
    }
    addClient(client) {
        this.clients.push(client);
    }
    resolveCloneParams({ ctx, clients = [], beforeSend = [], disableConsole, }) {
        return {
            ctx: LogOptionsHelper.merge(this.ctx.get(), ctx),
            clients: [...this.clients, ...clients],
            beforeSend: [...this.logOptionsResolvers, ...beforeSend],
            disableConsole: isNil(disableConsole)
                ? this.disableConsole
                : disableConsole,
        };
    }
    createLoggerWith(options) {
        return new BaseLogger(this.resolveCloneParams(options));
    }
    log(options) {
        const payload = LogOptionsHelper.merge(defaultLogOptions, this.ctx.get(), options);
        const resolvedPayload = this.logOptionsResolvers.length > 0
            ? this.logOptionsResolvers.reduce((acc, cur) => {
                return cur ? cur(acc) : acc;
            }, Object.assign({}, payload))
            : payload;
        this.clients.forEach((client) => {
            client.send(resolvedPayload);
        });
    }
    error(payload) {
        this.log(Object.assign(Object.assign({}, payload), { level: LogLevel.ERROR }));
    }
    warning(payload) {
        this.log(Object.assign(Object.assign({}, unwrapOptions(payload)), { level: LogLevel.WARNING }));
    }
    info(payload) {
        this.log(Object.assign(Object.assign({}, unwrapOptions(payload)), { level: LogLevel.INFO }));
    }
    success(payload) {
        this.log(Object.assign(Object.assign({}, unwrapOptions(payload)), { level: LogLevel.SUCCESS }));
    }
}
